import { AppShell } from '@/app/layout/AppShell';
import { ConfigWarning } from '@/app/layout/ConfigWarning';
import { ShellProvider } from '@/app/layout/ShellContext';
import { CompanySwitcher, SidebarNav } from '@/app/layout/Sidebar';
import { CompanyProvider } from '@/features/company/CompanyContext';

/**
 * The normal app's shell (§ Basis layout): `AppShell` with the active
 * company as its top slot and `SidebarNav` (every section, subpages always
 * visible) as its nav — the same shell Beheer/Profiel/Instellingen use,
 * just with a different top slot and nav.
 */
export function AppLayout() {
  return (
    <CompanyProvider>
      <ShellProvider>
        <AppShell
          topSlot={<CompanySwitcher />}
          renderNav={(onNavigate) => <SidebarNav onNavigate={onNavigate} />}
          beforeContent={<ConfigWarning />}
        />
      </ShellProvider>
    </CompanyProvider>
  );
}
